import type {ReactElement} from 'react';
import {Text, TextSize} from '@Components/text';
import type {RequestPreferenceCardProps} from './request-preference-card.types';
import styles from './request-preference-card.module.scss';

export function RequestPreferenceCard({label, value, detail, trailing, children}: RequestPreferenceCardProps): ReactElement {
  const getDetail = (): ReactElement | null => {
    if (detail === undefined) {
      return null;
    }
    return <Text val={detail} size={TextSize.XS} className={styles.detail} />;
  };

  return (
    <span className={styles.card}>
      <span className={styles.summary}>
        <span className={styles.identity}>
          <Text val={label} size={TextSize.XS} bold className={styles.label} />
          <Text val={value} size={TextSize.SM} bold className={styles.value} />
          {getDetail()}
        </span>
        {trailing}
      </span>
      {children}
    </span>
  );
}
